import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap, Image } from '../..';

import infoIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--info.svg';
import successIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--success.svg';
import warningIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--warning.svg';
import errorIcon from '../../../../../../styles/yurstrap/app/images/msg-box/msg-box__icon--error.svg';

const propTypes = { ...Abstrap.propTypes, type: PropTypes.oneOf(['info', 'success', 'warning', 'error']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    type: 'info',
};

class MessageBoxIcon extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-msg-box__icon',
            className,
        ];
    }

    renderChildren() {
        const { type } = this.props;
        let imageSrc = null;
        switch (type) {
            case 'success':
                imageSrc = successIcon;
                break;
            case 'warning':
                imageSrc = warningIcon;
                break;
            case 'error':
                imageSrc = errorIcon;
                break;
            default:
                imageSrc = infoIcon;
        }
        return (
            <Image src={imageSrc} />
        );
    }

}

MessageBoxIcon.propTypes = propTypes;

MessageBoxIcon.defaultProps = defaultProps;

export default MessageBoxIcon;
